import React from "react";
import {
  AppBar,
  Box,
  Button,
  CircularProgress,
  Dialog,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  makeStyles,
  Toolbar,
  Typography,
} from "@material-ui/core";
import { compose, lifecycle } from "recompose";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import CloseIcon from "@material-ui/icons/Close";
import Slide from "@material-ui/core/Slide";
import { MAIN_COLOR } from "../../shared/utils/constant";
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";
import ImageIcon from "@material-ui/icons/Image";
import UploadButton from "../RoadSurveyed/UploadButton";
import { authFileFetch } from "../../shared/utils/fetchUtils";
import { ApiEndpoint } from "../../env.config";
import FileSaver from "file-saver";

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: "relative",
    backgroundColor: MAIN_COLOR,
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  fileContainer: {
    backgroundColor: theme.palette.background.paper,
    height: "calc(100vh - 80px)",
    overflow: "auto",
  },
}));

function ManageS3Files({ loading, open, handleClose, files, userId }) {
  const classes = useStyles();
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

  const handleDownload = async (url, filename) => {
    try {
      const response = await authFileFetch(
        `${ApiEndpoint}/Road/surveyed/download?fileUrl=${url}`,
        { method: "GET" }
      );
      var blob = await response.blob();
      var filenameParts = filename.split(".");
      var extension = filenameParts[filenameParts.length - 1];
      var downloadfileName = filename.replace(/^.*[\\\/]/, "");
      downloadfileName = downloadfileName.includes(".csv")
        ? downloadfileName.substring(0, downloadfileName.indexOf(".csv"))
        : downloadfileName;
      FileSaver.saveAs(
        blob,
        extension === "csv" ? `${downloadfileName}.csv` : downloadfileName
      );
    } catch (error) {
      console.error(error);
    }
  };

  return (
    open && (
      <Dialog
        fullScreen
        open={true}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" className={classes.title}>
              Manage files
            </Typography>
            <UploadButton
              title="Add file"
              noImageUpload={true}
              userId={userId}
            />
          </Toolbar>
        </AppBar>
        <List>
          {loading ? (
            <Box textAlign="center">
              <CircularProgress />
            </Box>
          ) : (
            <div className={classes.fileContainer}>
              {files && files.length ? (
                <List>
                  {[...files].reverse().map((x, idx) => (
                    <ListItem key={idx}>
                      <ListItemAvatar>
                        {x.key.includes("jpg") ? (
                          <ImageIcon style={{ color: MAIN_COLOR }} />
                        ) : (
                          <InsertDriveFileIcon color="primary" />
                        )}
                      </ListItemAvatar>
                      <Button
                        style={{ textTransform: "initial" }}
                        onClick={() =>
                          handleDownload(
                            `https://${x.bucketName}.s3-us-east-2.amazonaws.com/${x.key}`,
                            `${
                              x.key.includes("csv")
                                ? x.key.split(".csv")[0] + ".csv"
                                : x.key
                            }`
                          )
                        }
                      >
                        <ListItemText primary={x.key} />
                      </Button>
                    </ListItem>
                  ))}
                </List>
              ) : (
                <Box textAlign="center">
                  <Typography>There is no data</Typography>
                </Box>
              )}
            </div>
          )}
        </List>
      </Dialog>
    )
  );
}

export default compose(
  withTranslation("translations"),
  connect(
    (state) => ({
      loading: state.setting.loading,
      files: state.setting.files,
    }),
    (dispatch) => ({
      //   getData: () => dispatch(GetSetting()),
    })
  ),
  lifecycle({
    componentDidMount() {
      //   this.props.getData();
    },
  })
)(ManageS3Files);
